import Immutable, { Record, List } from 'immutable';

import SubSkillResult from './SubSkillResults';

const SkillResultRecord = Record({
  previousResult: undefined,
  isRubric: undefined,
  isAbandoned: undefined,
  skillId: undefined,
  currentResult: undefined,
  fullMark: undefined,  // leave this here for rubric fullMark calculation
  subSkillResults: new List(),
  suggestions: new List(),
  markedBy: undefined,
  markedTime: undefined,
});

class SkillResult extends SkillResultRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillId':
      return [key, `${val}`];
    case 'subSkillResults':
      return [key, new List(val.map(SubSkillResult.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

SkillResult.create = (data) =>
  new SkillResult(data).mapEntries(reviver);

export default SkillResult;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/SkillResults/model.js